module.exports = __webpack_public_path__ + "img/location.a5d3b5be.svg";